module.exports={render:function (){with(this) {
  return _h('button', {
    class: ("social-button network-" + network),
    domProps: {
      "innerHTML": _s(image[network])
    },
    on: {
      "click": handleClick
    }
  })
}},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-1665feea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SocialButton.vue
 ** module id = 164
 ** module chunks = 2
 **/